import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';

import { AuthProvider } from '@/lib/auth/AuthProvider';
import { queryClient } from './query-client';

/**
 * AppProviders — envuelve la app con los providers globales:
 *  - React Query (mismo QueryClient que expone el router como context).
 *  - Sonner Toaster (bottom-left, richColors).
 *  - AuthProvider (sesion Supabase).
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <Toaster position="bottom-left" richColors />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default AppProviders;
